//components
import {CancelConfirmPanel} from 'thrive-components';
import ModalWrapper from  '@/components/modals/ModalWrapper';

//styling
import "../../../../css/global/Modals/passkey-data-modal.scss";



const RevokeCodeModal = ({showModal, hideModal, onConfirmClick} : {showModal: boolean, hideModal: () => void, onConfirmClick: ()=>void}) => {
    return (
        <>
        <ModalWrapper 
            isOpen={showModal} 
            onRequestClose={hideModal} 
            className="revoke-code-modal" 
            isFullPage
        >
                <div className="revoke-code-modal-content">
                     <h1 className='header-text'>Revoke Recovery Code</h1> 
            
                    <div>
                        Are you sure you want to revoke the recovery code?
                    </div>
                                
                    <CancelConfirmPanel 
                        panelClassName={'revoke-button-panel'}
                        cancelContent={'Cancel'} 
                        confirmContent={'Confirm'} 
                        ariaLabelCancel={'Cancel and close modal'} 
                        ariaLabelConfirm={'Confirm and revoke code'} 
                        onCancelClick={hideModal}
                        onConfirmClick={onConfirmClick}
                    />
                </div>
        </ModalWrapper> 
        </>
    );  
}

export default RevokeCodeModal;
